import React, { useState } from 'react';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import FormattedMessageWithClass from '../formattedMessageWithClass/index';
import styles from './tags.module.scss';
import CloseIcon from '../../icons/close.svg';

function Tags(props) {
    const { handleTagSelect, opsLogTags, handleTagSelectProps, module, handleRemoveTag, updatedOpslogTags, updatedOpsOldTags } = props;
    const [showDropDown, setShowDropDown] = useState(false);
    const handleDropDown = () => {
      setShowDropDown(prev => !prev);
    };
  return (
    <>
      {opsLogTags!==undefined && handleTagSelect
      && <div className={module=== 'leaseMangementWO' || module === 'inspections' || module === 'permitSkilltest' ? '' : styles.container5}>
          <FormattedMessageWithClass
            className={styles.label}
            id="operations.create.tags"
            defaultMessage="Tags" />
          <div style={{ position: 'relative' }}>
          <LocalOfferIcon style={{ color: '#8c9ea7' }} onClick={handleDropDown} />
            {showDropDown
                && <ul className={`${styles.actionpopup} ${showDropDown ? styles.open : ''}`}>
                    {opsLogTags?.map(tag => <li role="presentation"
                    key={tag?.id}
                      className={styles.item}
                      onClick={() => {
                        if (module === 'workOrder' || module === 'leaseMangementWO') {
                          handleTagSelect(handleTagSelectProps[0], tag || [], handleTagSelectProps[1]);
                        } else if (module === 'inspectionCreate'|| module === 'forms' || module === 'inspections' || module === 'permitSkilltest') {
                          handleTagSelect(tag || [], handleTagSelectProps[0]);
                        }
                        return handleDropDown();
                        }
                        }>
                      {tag?.name}
                                            </li>)}
                   </ul>}
          </div>
          <div className={styles.tagContainer}>
          {updatedOpslogTags
            &&updatedOpslogTags?.map(e => <span className={styles.tag}>{e.name} <img src={CloseIcon} alt="close"
              onClick={() => handleRemoveTag(e)} role="presentation"
              style={{ width: '18px', marginLeft: '10px', background: '#fff', cursor: 'pointer', borderRadius: '25px' }}
            />
                                          </span>)
          }
          {
            updatedOpsOldTags
            &&updatedOpsOldTags?.map(e => <span className={`${styles.tag} ${styles.oldTag}`}>{e.name} <img src={CloseIcon} alt="close"
              onClick={() => handleRemoveTag(e, 'old')} role="presentation"
              style={{ width: '18px', marginLeft: '10px', background: '#fff', cursor: 'pointer', borderRadius: '25px' }}
            />
                                          </span>)
          }
          </div>
         </div>}
    </>
  );
}

export default Tags;
